import { FC, useState } from 'react';
import { IconLogoMobile } from '../Icons/IconLogoMobile';
import './HeaderNavigatorMobile.css';
import { IconClose } from '../Icons';
import { IconDropDownArrowRounded } from '../Icons/IconDropDownArrowRounded';
import { Link } from 'react-router-dom';
import { IconPreparacion } from '../Icons/IconPreparacion';
import { IconCostosPrecios } from '../Icons/IconCostosPrecios';
import { IconMercado } from '../Icons/IconMercado';
import { IconNovedades } from '../Icons/IconNovedades';
import { IconSobreNosotros } from '../Icons/IconSobreNosotros';
import { IconHome } from '../Icons/IconHome';
import { useTranslation } from 'react-i18next';
const HeaderNavigatorMobile: FC<{ onClose: () => void }> = ({ onClose }) => {
	const { t } = useTranslation();
	const [isPreparacionDropdownOpen, setIsPreparacionDropdownOpen] = useState(false);
	const [isCostosPreciosDropdownOpen, setIsCostosPreciosDropdownOpen] = useState(false);
	const [isMercadoDropdownOpen, setIsMercadoDropdownOpen] = useState(false);
	const [isNovedadesDropdownOpen, setIsNovedadesDropdownOpen] = useState(false);
	const [isSobreNosotrosDropdownOpen, setIsSobreNosotrosDropdownOpen] = useState(false);

	const togglePreparacionDropdown = () => {
		setIsPreparacionDropdownOpen(!isPreparacionDropdownOpen);
		setIsCostosPreciosDropdownOpen(false);
		setIsMercadoDropdownOpen(false);
		setIsNovedadesDropdownOpen(false);
		setIsSobreNosotrosDropdownOpen(false);
	};
	const toggleCostosPreciosDropdown = () => {
		setIsCostosPreciosDropdownOpen(!isCostosPreciosDropdownOpen);
		setIsPreparacionDropdownOpen(false);
		setIsMercadoDropdownOpen(false);
		setIsNovedadesDropdownOpen(false);
		setIsSobreNosotrosDropdownOpen(false);
	};
	const toggleMercadoDropdown = () => {
		setIsMercadoDropdownOpen(!isMercadoDropdownOpen);
		setIsPreparacionDropdownOpen(false);
		setIsCostosPreciosDropdownOpen(false);
		setIsNovedadesDropdownOpen(false);
		setIsSobreNosotrosDropdownOpen(false);
	};

	const toggleNovedadesDropdown = () => {
		setIsNovedadesDropdownOpen(!isNovedadesDropdownOpen);
		setIsPreparacionDropdownOpen(false);
		setIsCostosPreciosDropdownOpen(false);
		setIsMercadoDropdownOpen(false);
		setIsSobreNosotrosDropdownOpen(false);
	};

	const toggleSobreNosotrosDropdown = () => {
		setIsSobreNosotrosDropdownOpen(!isSobreNosotrosDropdownOpen);
		setIsPreparacionDropdownOpen(false);
		setIsCostosPreciosDropdownOpen(false);
		setIsMercadoDropdownOpen(false);
		setIsNovedadesDropdownOpen(false);
	};
	return (
		<div className="header-navigator-mobile">
			<div className="header-navigator-mobile__top">
				<div
					className="header-navigator-mobile__logo"
					onClick={onClose}>
					<IconLogoMobile />
					<IconDropDownArrowRounded className="header-navigator-mobile__logo__icon" />
				</div>
				<button
					className="header-navigator-mobile__button"
					onClick={onClose}>
					<IconClose fill="white" />
				</button>
			</div>
			<div className="header-navigator-mobile__bottom">
				<div className="header-navigator-mobile__item">
					<div className={`header-navigator-mobile__dropdown `}>
						<div className="header-navigator-mobile__dropdown__content">
							<div className="header-navigator-mobile__dropdown__content__header">
								<Link to="/">
									<span className="header-navigator-mobile__dropdown__content__header__text">
										<IconHome className="header-navigator-mobile__dropdown__content__header__icon" />
										{t('navigation.home')}
									</span>
								</Link>
							</div>
						</div>
					</div>
					<span className="header-navigator-mobile__title">{t('navigation.tools')}</span>

					<div className={`header-navigator-mobile__dropdown ${isPreparacionDropdownOpen ? 'active' : ''}`}>
						<div className="header-navigator-mobile__dropdown__content">
							<div
								className="header-navigator-mobile__dropdown__content__header"
								onClick={togglePreparacionDropdown}>
								<span className="header-navigator-mobile__dropdown__content__header__text">
									<IconPreparacion className="header-navigator-mobile__dropdown__content__header__icon" />
									{t('navigation.preparation')}
								</span>
								<IconDropDownArrowRounded className="header-navigator-mobile__dropdown__content__header__arrow-icon" />
							</div>
							<div className="header-navigator-mobile__dropdown__content__items">
								<Link
									to="/exportertest"
									className="header-navigator-mobile__dropdown__content__item__link">
									{t('navigation.test_exportador')}
								</Link>
								<Link
									to="https://compliance.exportopia.eu/"
									target="_blank"
									className="header-navigator-mobile__dropdown__content__item__link">
									{t('navigation.compliance_module')}
								</Link>
								<Link
									to="/"
									className="header-navigator-mobile__dropdown__content__item__link">
									{t('navigation.limits')}
								</Link>
							</div>
						</div>
					</div>
					<div className={`header-navigator-mobile__dropdown ${isCostosPreciosDropdownOpen ? 'active' : ''}`}>
						<div className="header-navigator-mobile__dropdown__content">
							<div
								className="header-navigator-mobile__dropdown__content__header"
								onClick={toggleCostosPreciosDropdown}>
								<span className="header-navigator-mobile__dropdown__content__header__text">
									<IconCostosPrecios className="header-navigator-mobile__dropdown__content__header__icon" />
									{t('navigation.costs_and_prices')}
								</span>
								<IconDropDownArrowRounded className="header-navigator-mobile__dropdown__content__header__arrow-icon" />
							</div>
							<div className="header-navigator-mobile__dropdown__content__items">
								<Link
									to="/cubicaje"
									className="header-navigator-mobile__dropdown__content__item__link">
									{t('navigation.palletized_calculator')}
								</Link>

								<Link
									to="/"
									className="header-navigator-mobile__dropdown__content__item__link">
									{t('navigation.calculate_fob')}
								</Link>

								<Link
									to="/calcularprecios"
									className="header-navigator-mobile__dropdown__content__item__link">
									{t('navigation.price_calculator')}
								</Link>
							</div>
						</div>
					</div>
					<div className={`header-navigator-mobile__dropdown ${isMercadoDropdownOpen ? 'active' : ''}`}>
						<div className="header-navigator-mobile__dropdown__content">
							<div
								className="header-navigator-mobile__dropdown__content__header"
								onClick={toggleMercadoDropdown}>
								<span className="header-navigator-mobile__dropdown__content__header__text">
									<IconMercado className="header-navigator-mobile__dropdown__content__header__icon" />
									{t('navigation.markets')}
								</span>
								<IconDropDownArrowRounded className="header-navigator-mobile__dropdown__content__header__arrow-icon" />
							</div>
							<div className="header-navigator-mobile__dropdown__content__items">
								<Link
									to="/"
									className="header-navigator-mobile__dropdown__content__item__link">
									{t('navigation.ferias_international')}
								</Link>
								<Link
									to="/pricecomparator"
									className="header-navigator-mobile__dropdown__content__item__link">
									{t('navigation.price_comparator_european')}
								</Link>
							</div>
						</div>
					</div>

					<span className="header-navigator-mobile__title">{t('navigation.resources')}</span>

					<div className={`header-navigator-mobile__dropdown ${isNovedadesDropdownOpen ? 'active' : ''}`}>
						<div className="header-navigator-mobile__dropdown__content">
							<div
								className="header-navigator-mobile__dropdown__content__header"
								onClick={toggleNovedadesDropdown}>
								<span className="header-navigator-mobile__dropdown__content__header__text">
									<IconNovedades className="header-navigator-mobile__dropdown__content__header__icon" />
									{t('navigation.news')}
								</span>
								<IconDropDownArrowRounded className="header-navigator-mobile__dropdown__content__header__arrow-icon" />
							</div>
							<div className="header-navigator-mobile__dropdown__content__items">
								<Link
									to="/acerca-interconectar"
									className="header-navigator-mobile__dropdown__content__item__link">
									{t('navigation.who_we_are')}
								</Link>
								<Link
									to="/servicios"
									className="header-navigator-mobile__dropdown__content__item__link">
									{t('navigation.other_services')}
								</Link>
							</div>
						</div>
					</div>
					<div className={`header-navigator-mobile__dropdown ${isSobreNosotrosDropdownOpen ? 'active' : ''}`}>
						<div className="header-navigator-mobile__dropdown__content">
							<div
								className="header-navigator-mobile__dropdown__content__header"
								onClick={toggleSobreNosotrosDropdown}>
								<span className="header-navigator-mobile__dropdown__content__header__text">
									<IconSobreNosotros className="header-navigator-mobile__dropdown__content__header__icon" />
									{t('navigation.about_us')}
								</span>
								<IconDropDownArrowRounded className="header-navigator-mobile__dropdown__content__header__arrow-icon" />
							</div>
							<div className="header-navigator-mobile__dropdown__content__items">
								<Link
									to="/search"
									className="header-navigator-mobile__dropdown__content__item__link">
									{t('navigation.news')}
								</Link>
								<Link
									to="/sugerencias"
									className="header-navigator-mobile__dropdown__content__item__link">
									{t('navigation.suggestions')}
								</Link>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default HeaderNavigatorMobile;
